<template>
  <div class="h-100" v-bind:class="{'pt-5 pb-5': resultPage.isMobile === true}">
    <div class="h-100">
      <div class="gallery-1 justify-content-center pb-20 h-100 ">
        <div class="placeholder" v-if="loading">
          <div class="animated-background"></div>
        </div>
        <div class="container" v-if="complete === true">
          <div class="alert alert-info" v-if="output_too_large === true">
            {{ 'File is too large for preview' | trans }}
          </div>
          <div class="alert alert-warning" v-if="output_failed === true">
            {{ 'Could not get file for preview' | trans }}
          </div>
          <div class="card" v-if="output_too_large === false && output_failed === false">
            <div class="card-body text-output">{{ output_content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import axios from 'axios';
import {EventBus} from "../../../events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../events/job.events";

export default {
  name: "OutputTxt",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      output_content: '',
      output_too_large: false,
      output_failed: false
    };
  },
  mounted: function () {
    this.getOutputContent();
  },
  created: function () {
    this.getOutputContent();

    EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
      this.getOutputContent();
    });
  },
  methods: {
    getOutputContent() {
      if (this.output_content !== '') {
        return;
      }
      if (this.currentJob.state !== 'completed') {
        return;
      }

      if (this.currentOutput.size > 2000000) {
        this.output_too_large = true;
        return;
      }

      if (typeof this.currentOutput.previewContent !== 'undefined') {
        this.output_content = this.currentOutput.previewContent;
        return;
      }

      let that = this;
      axios.get(this.currentOutput.uri).then((response) => {
        this.output_content = response.data;
        this.currentOutput.previewContent = response.data;
      }).catch(function (error) {
        that.output_failed = true;
      })
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.text-output {
  white-space: pre-line;
}

.gallery-1 {
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.placeholder {
  margin: 0 auto;
  width: 100%;
  min-height: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius: 9px;
  overflow: hidden;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
}

.gallery-1 {
  display: flex;
  gap: 20px;

  img {
    object-fit: contain;
    object-position: top;
    height: 100%;
    width: 100%;
    padding-bottom: 20px;
  }
}

.image {
  object-fit: contain;
  object-position: top;
  display: flex;
  justify-content: center;
}

.loading .image,
.loading h4,
.loading .description {
  background-color: #383838;
  background: linear-gradient(
          100deg,
          rgba(255, 255, 255, 0) 40%,
          rgba(255, 255, 255, .1) 50%,
          rgba(255, 255, 255, 0) 60%
  ) #383838;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-in-out infinite;


}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
</style>
